import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { getIconByName } from '../get-icon-by-name.js';

const defaultWidth = 24;
const defaultHeight = 24;
const Icon = (_param)=>{
    var { name ='' , width =defaultWidth , height =defaultHeight , viewBox =`0 0 ${defaultWidth} ${defaultHeight}` , className , style  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "name",
        "width",
        "height",
        "viewBox",
        "className",
        "style"
    ]);
    const classname = classnames('icon', `icon--${name}`, className);
    // doesn't jump when the icons are loading
    const fallback = /*#__PURE__*/ React.createElement("div", {
        className: classname,
        style: {
            width,
            height
        }
    });
    const IconByName = getIconByName(name);
    if (!IconByName || typeof window === 'undefined') {
        return fallback;
    }
    return /*#__PURE__*/ React.createElement(React.Suspense, {
        fallback: fallback
    }, /*#__PURE__*/ React.createElement(IconByName, swcHelpers.extends({
        style: style,
        viewBox: viewBox,
        width: `${width}px`,
        height: `${height}px`,
        className: classname,
        "data-t": rest['data-t'],
        "aria-hidden": 'true',
        role: "img",
        alt: ""
    }, rest)));
};
var Icon$1 = Icon;

export { Icon$1 as default };
//# sourceMappingURL=Icon.js.map
